interface JsonBlockProps {
  title: string;
  value: unknown;
  defaultOpen?: boolean;
}

export function JsonBlock({ title, value, defaultOpen }: JsonBlockProps) {
  const empty = value === undefined || value === null || (typeof value === 'object' && Object.keys(value as object).length === 0);
  return (
    <details open={defaultOpen} className="rounded-md border">
      <summary className="cursor-pointer select-none px-3 py-2 text-sm font-medium">
        {title} {empty && <span className="text-muted-foreground">(empty)</span>}
      </summary>
      {!empty && (
        // Focusable so keyboard users can scroll it; long values wrap instead of widening the dialog.
        <pre
          tabIndex={0}
          role="region"
          aria-label={`${title} content`}
          className="max-h-80 overflow-auto border-t bg-muted/40 p-3 font-mono text-xs whitespace-pre-wrap [overflow-wrap:anywhere] outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {typeof value === 'string' ? value : JSON.stringify(value, null, 2)}
        </pre>
      )}
    </details>
  );
}
